export enum APP_ENV {
    DEV = 'dev',
    DEV_EXTERNAL = 'dev-external',
    TEST = 'test',
    QA = 'qa',
    RELEASE = 'release',
    PROD = 'prod',
}

export const currentAppEnv = () => globalThis.VITE_APP_ENV as APP_ENV;
export const isDev = () => currentAppEnv() === APP_ENV.DEV;
export const isProd = () => currentAppEnv() === APP_ENV.PROD;
export const isTest = () => currentAppEnv() === APP_ENV.TEST;
